import {
    Box,
    Button,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { ArrowLeft, DivideIcon, PlusCircle } from "lucide-react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import LoadingGif from "../components/LoadingGif";
import { useState, useEffect } from "react";

const MOCK_ROOMS = [
    {
        "roomId": "6a9fccbfbba3bf2150453a78", //maybe Mongodb Id,
        "hotelId": "64f1a2b3c4d5e6f7a8b9c0d1",
        "status": "editing",
        "infomation1": {
            "_id": "6a9fccbfbba3bf2150453a78",
            "roomName": "Playground",
            "roomQuantity": 2,
            "dimensions": { "length": 3.5, "width": 2.8, "height": 2.5 },
            "petTypes": ["cat", "rabbit"],
            "petQuantity": 5,
            "description": "Comfortable room for small pets",
            "weekdayPrice": 120,
            "weekendPrice": 150,
            "freeCancelDeadline": "7days",
            "lateCancelFee": "fixed",
            "fixedFeePercentage": 4
        },
        "information2": {
            "heating24h": true,
            "heatingFee": "20 THB per hour",
            "petPhotosVideos": true,
            "customSnacks": true,
            "ventilation24h": true,
            "dailyDisinfection": true,
            "dailyInteraction": true,
            "customRequests": true,
            "hasWindow": true,
            "lateCheckout": true,
            "lateCheckoutFee": "100 THB"
        },
        "information3": {
            "promotionChoice": "earlyBird",
            "earlyBirdDiscount": 10,
            "earlyBirdDiscountDays": 5,
            "addonDiscount": null,
            "customPromotions": null
        },
    },
    {
        "roomId": "6a9fccbfbba3bf2150453a78", //maybe Mongodb Id,
        "hotelId": "64f1a2b3c4d5e6f7a8b9c0d1",
        "status": "editing",
        "infomation1": {
            "_id": "6a9fccbfbba3bf2150453a78",
            "roomName": "Playground",
            "roomQuantity": 2,
            "dimensions": { "length": 3.5, "width": 2.8, "height": 2.5 },
            "petTypes": ["cat", "rabbit"],
            "petQuantity": 5,
            "description": "Comfortable room for small pets",
            "weekdayPrice": 120,
            "weekendPrice": 150,
            "freeCancelDeadline": "7days",
            "lateCancelFee": "fixed",
            "fixedFeePercentage": 4
        },
        "information2": {
            "heating24h": true,
            "heatingFee": "20 THB per hour",
            "petPhotosVideos": true,
            "customSnacks": true,
            "ventilation24h": true,
            "dailyDisinfection": true,
            "dailyInteraction": true,
            "customRequests": true,
            "hasWindow": true,
            "lateCheckout": true,
            "lateCheckoutFee": "100 THB"
        },
        "information3": {
            "promotionChoice": "earlyBird",
            "earlyBirdDiscount": 10,
            "earlyBirdDiscountDays": 5,
            "addonDiscount": null,
            "customPromotions": null
        },
    },
    {
        "roomId": "6a9fccbfbba3bf2150453a78", //maybe Mongodb Id,
        "hotelId": "64f1a2b3c4d5e6f7a8b9c0d1",
        "status": "published",
        "infomation1": {
            "_id": "6a9fccbfbba3bf2150453a78",
            "roomName": "Playground",
            "roomQuantity": 2,
            "dimensions": { "length": 3.5, "width": 2.8, "height": 2.5 },
            "petTypes": ["cat", "rabbit"],
            "petQuantity": 5,
            "description": "Comfortable room for small pets",
            "weekdayPrice": 120,
            "weekendPrice": 150,
            "freeCancelDeadline": "7days",
            "lateCancelFee": "fixed",
            "fixedFeePercentage": 4
        },
        "information2": {
            "heating24h": true,
            "heatingFee": "20 THB per hour",
            "petPhotosVideos": true,
            "customSnacks": true,
            "ventilation24h": true,
            "dailyDisinfection": true,
            "dailyInteraction": true,
            "customRequests": true,
            "hasWindow": true,
            "lateCheckout": true,
            "lateCheckoutFee": "100 THB"
        },
        "information3": {
            "promotionChoice": "earlyBird",
            "earlyBirdDiscount": 10,
            "earlyBirdDiscountDays": 5,
            "addonDiscount": null,
            "customPromotions": null
        },
    },
    {
        "roomId": "6a9fccbfbba3bf2150453a78", //maybe Mongodb Id,
        "hotelId": "64f1a2b3c4d5e6f7a8b9c0d1",
        "status": "published",
        "infomation1": {
            "_id": "6a9fccbfbba3bf2150453a78",
            "roomName": "Playground",
            "roomQuantity": 2,
            "dimensions": { "length": 3.5, "width": 2.8, "height": 2.5 },
            "petTypes": ["cat", "rabbit"],
            "petQuantity": 5,
            "description": "Comfortable room for small pets",
            "weekdayPrice": 120,
            "weekendPrice": 150,
            "freeCancelDeadline": "7days",
            "lateCancelFee": "fixed",
            "fixedFeePercentage": 4
        },
        "information2": {
            "heating24h": true,
            "heatingFee": "20 THB per hour",
            "petPhotosVideos": true,
            "customSnacks": true,
            "ventilation24h": true,
            "dailyDisinfection": true,
            "dailyInteraction": true,
            "customRequests": true,
            "hasWindow": true,
            "lateCheckout": true,
            "lateCheckoutFee": "100 THB"
        },
        "information3": {
            "promotionChoice": "earlyBird",
            "earlyBirdDiscount": 10,
            "earlyBirdDiscountDays": 5,
            "addonDiscount": null,
            "customPromotions": null
        },
    },
    {
        "roomId": "6a9fccbfbba3bf2150453a78", //maybe Mongodb Id,
        "hotelId": "64f1a2b3c4d5e6f7a8b9c0d1",
        "status": "unpublished",
        "infomation1": {
            "_id": "6a9fccbfbba3bf2150453a78",
            "roomName": "Playground",
            "roomQuantity": 2,
            "dimensions": { "length": 3.5, "width": 2.8, "height": 2.5 },
            "petTypes": ["cat", "rabbit"],
            "petQuantity": 5,
            "description": "Comfortable room for small pets",
            "weekdayPrice": 120,
            "weekendPrice": 150,
            "freeCancelDeadline": "7days",
            "lateCancelFee": "fixed",
            "fixedFeePercentage": 4
        },
        "information2": {
            "heating24h": true,
            "heatingFee": "20 THB per hour",
            "petPhotosVideos": true,
            "customSnacks": true,
            "ventilation24h": true,
            "dailyDisinfection": true,
            "dailyInteraction": true,
            "customRequests": true,
            "hasWindow": true,
            "lateCheckout": true,
            "lateCheckoutFee": "100 THB"
        },
        "information3": {
            "promotionChoice": "earlyBird",
            "earlyBirdDiscount": 10,
            "earlyBirdDiscountDays": 5,
            "addonDiscount": null,
            "customPromotions": null
        },
    },
    {
        "roomId": "6a9fccbfbba3bf2150453a78", //maybe Mongodb Id,
        "hotelId": "64f1a2b3c4d5e6f7a8b9c0d1",
        "status": "unpublished",
        "infomation1": {
            "_id": "6a9fccbfbba3bf2150453a78",
            "roomName": "Playground",
            "roomQuantity": 2,
            "dimensions": { "length": 3.5, "width": 2.8, "height": 2.5 },
            "petTypes": ["cat", "rabbit"],
            "petQuantity": 5,
            "description": "Comfortable room for small pets",
            "weekdayPrice": 120,
            "weekendPrice": 150,
            "freeCancelDeadline": "7days",
            "lateCancelFee": "fixed",
            "fixedFeePercentage": 4
        },
        "information2": {
            "heating24h": true,
            "heatingFee": "20 THB per hour",
            "petPhotosVideos": true,
            "customSnacks": true,
            "ventilation24h": true,
            "dailyDisinfection": true,
            "dailyInteraction": true,
            "customRequests": true,
            "hasWindow": true,
            "lateCheckout": true,
            "lateCheckoutFee": "100 THB"
        },
        "information3": {
            "promotionChoice": "earlyBird",
            "earlyBirdDiscount": 10,
            "earlyBirdDiscountDays": 5,
            "addonDiscount": null,
            "customPromotions": null
        },
    },
];

const RoomManagement = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { id } = useParams();
    const isMobile = useMediaQuery("(max-width:950px)");
    const [filter, setFilter] = useState("all");

    const pageStyle = {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#F5F5F5",
    };

    const contentStyle = {
        flex: "1 0 auto",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: isMobile ? "100px 20px 60px" : "120px 80px 80px",
        maxWidth: "1600px",
        width: "100%",
    };

    const filterButtonStyle = {
        borderRadius: "10px",
        padding: "8px 16px",
        textTransform: "none",
        fontSize: "16px",
        display: "flex",
        alignItems: "center",
        gap: 1,
        border: "1px solid #99A1AF",
        cursor: "pointer",
    };

    return (
        <div style={pageStyle}>
            <Navbar />
            <div style={contentStyle}>

                <Box sx={{ width: isMobile ? "100%" : "60%", mx: "auto", display: "flex", flexDirection: "column" }}>
                    {/* Heading */}
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 3 }}>
                        <Button
                            onClick={() => navigate("/hotel/onboarding")}
                            sx={{
                                minWidth: "auto",
                                width: isMobile ? "36px" : "44px",
                                height: isMobile ? "36px" : "44px",
                                borderRadius: "50%",
                                backgroundColor: "#31BACD",
                                color: "#fff",
                                padding: 0,
                                "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                            }}
                        >
                            <ArrowLeft size={isMobile ? 18 : 22} />
                        </Button>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                            <Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "20px" : "24px", color: "#000" }}>
                                {t('RoomManagementTitle')}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: isMobile ? "13px" : "14px",
                                    color: "#666",
                                }}
                            >
                                {t('RoomManagementDesc')}
                            </Typography>
                        </Box>
                    </Box>

                    {false ? (
                        <LoadingGif />
                    ) : (
                        <Box sx={{ width: "100%" }}>
                            {/* Filter bar */}
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3, gap: 2, flexWrap: "wrap" }}>
                                <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
                                    <Button
                                        onClick={() => setFilter("editing")}
                                        sx={{
                                            ...filterButtonStyle,
                                            backgroundColor: filter === "editing" ? "#FFB60D" : "#fff",
                                            color: filter === "editing" ? "#fff" : "#000",
                                            "&:hover": {
                                                backgroundColor: "#FFB60D",
                                            },
                                        }}
                                    >
                                        <img src={filter === "editing" ? "/icons/roomEditingSelected.svg" : "/icons/roomEditing.svg"} alt="editing" style={{ width: "16px", height: "16px" }} />
                                        <div>{t('Editing')}</div>
                                    </Button>
                                    <Button
                                        onClick={() => setFilter("published")}
                                        sx={{
                                            ...filterButtonStyle,
                                            backgroundColor: filter === "published" ? "#00A63E" : "#fff",
                                            color: filter === "published" ? "#fff" : "#000",
                                            "&:hover": {
                                                backgroundColor: "#00A63E",
                                            },
                                        }}
                                    >
                                        <img src={filter === "published" ? "/icons/roomPublishedSelected.svg" : "/icons/roomPublished.svg"} alt="published" style={{ width: "16px", height: "16px", }} />
                                        <div>{t('Published')}</div>
                                    </Button>
                                    <Button
                                        onClick={() => setFilter("unpublished")}
                                        sx={{
                                            ...filterButtonStyle,
                                            backgroundColor: filter === "unpublished" ? "#FF6900" : "#fff",
                                            color: filter === "unpublished" ? "#fff" : "#000",
                                            "&:hover": {
                                                backgroundColor: "#FF6900",
                                            },
                                        }}
                                    >
                                        <img src={filter === "unpublished" ? "/icons/roomUnpublishedSelected.svg" : "/icons/roomUnpublished.svg"} alt="unpublished" style={{ width: "16px", height: "16px" }} />
                                        <div>{t('Unpublished')}</div>
                                    </Button>
                                    <Button
                                        onClick={() => setFilter("all")}
                                        sx={{
                                            color: filter === "all" ? "#31BACD" : "#999",
                                            textTransform: "none",
                                            fontSize: "14px",
                                            textDecoration: filter === "all" ? "underline" : "none",
                                        }}
                                    >
                                        {t('ViewAll')}
                                    </Button>
                                </Box>
                                <Button
                                    onClick={() => navigate(`/room/add/${id}`)}
                                    sx={{
                                        backgroundColor: "#31BACD",
                                        color: "#fff",
                                        borderRadius: "10px",
                                        padding: "10px 16px",
                                        textTransform: "none",
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                                    }}
                                >
                                    <PlusCircle size={18} />
                                    {t('AddRoom')}
                                </Button>
                            </Box>

                            {/* Room cards */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                {MOCK_ROOMS.map((room) => (
                                    <Box
                                        key={room.roomId}
                                        sx={{
                                            display: "flex",
                                            gap: 2,
                                            padding: "16px",
                                            backgroundColor: "#fff",
                                            borderRadius: "10px",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        {/* Room thumbnail */}
                                        <Box
                                            sx={{
                                                width: "80px",
                                                height: "80px",
                                                backgroundColor: "#E0E0E0",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <Box component="img" src="/icons/room-placeholder.svg" alt="room" sx={{ width: 40, height: 40 }} />
                                        </Box>

                                        {/* Room info */}
                                        <Box sx={{ flex: 1 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                                                <Box
                                                    sx={{
                                                        backgroundColor: room.status === "editing" ? "#FF9800" : room.status === "published" ? "#4CAF50" : "#FF5722",
                                                        color: "#fff",
                                                        padding: "4px 12px",
                                                        borderRadius: "20px",
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    {room.status === "editing" ? "編輯中" : room.status === "published" ? "刊登中" : "暫停刊登"}
                                                </Box>
                                            </Box>
                                            <Typography sx={{ fontWeight: "600", fontSize: "16px", color: "#000", mb: 1 }}>
                                                {room.infomation1.roomName}
                                            </Typography>
                                            <Box sx={{ display: "flex", gap: 2, fontSize: "13px", color: "#666", flexWrap: "wrap" }}>
                                                <Typography sx={{ fontSize: "13px", color: "#666" }}>
                                                    創建於：{new Date().toLocaleDateString('zh-TW')}
                                                </Typography>
                                                <Typography sx={{ fontSize: "13px", color: "#666" }}>進度進度：{room.infomation1.roomQuantity}/3</Typography>
                                            </Box>
                                        </Box>

                                        {/* Action buttons */}
                                        <Box sx={{ display: "flex", gap: 1, flexDirection: "column", alignItems: "flex-end" }}>
                                            <Button
                                                sx={{
                                                    backgroundColor: room.status === "editing" ? "#4CAF50" : "#FF9800",
                                                    color: "#fff",
                                                    padding: "6px 12px",
                                                    borderRadius: "6px",
                                                    textTransform: "none",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {room.status === "editing" ? "查看" : room.status === "published" ? "編輯" : "編輯"}
                                            </Button>
                                            <Button
                                                sx={{
                                                    backgroundColor: room.status === "editing" ? "#4CAF50" : "#FF9800",
                                                    color: "#fff",
                                                    padding: "6px 12px",
                                                    borderRadius: "6px",
                                                    textTransform: "none",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {room.status === "editing" ? "查看" : room.status === "published" ? "編輯" : "編輯"}
                                            </Button>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                </Box>
            </div>
            <Footer />
        </div>
    );
};

export default RoomManagement;
